module.exports = __webpack_public_path__ + "static/img/network-error.5c4a545.png";


//////////////////
// WEBPACK FOOTER
// ./src/assert/network-error.png
// module id = uIWZ
// module chunks = 1